import { ProviderType } from 'features/connections'
import { ReactNode } from 'react'

export enum IntegrationType {
  ExternalIdp = 'external-idp',

  // buckets
  RedshiftImport = 'redshift-s3-imports',
  PostgresRdsExport = 'postgres-s3-exports',

  BQWorkloadIdentityFederation = 'bq-identity-federation',
  DatabricksOAuthU2M = 'databricks-oauth-u2m'
}

export type Integration = {
  integrationType: IntegrationType

  isLoading?: boolean
  id?: string
  icon: JSX.Element
  title: string | ReactNode
  description: string | ReactNode
  createdAt?: Date
  config?: unknown
}

export enum BucketProvider {
  S3 = 's3'
}

export interface S3BucketConfig {
  bucket: string
  region: string
  policy?: string
  accessKeyId?: string
  secretAccessKey?: string
}

export type Bucket = {
  integrationType: IntegrationType
  id?: string
  name: string
  createdAt?: Date

  storageProvider: BucketProvider
  config: unknown
}

export type BucketIntegration = Integration & Bucket

export interface S3Bucket extends Bucket {
  integrationType: IntegrationType
  storageProvider: BucketProvider.S3
  config: S3BucketConfig
}

export type ExternalIdpIntegration = Integration & {
  integrationType: IntegrationType.ExternalIdp
} & ExternalIdp

export type ExternalIdp = {
  id?: string
  idp: IDP
  name: string
  authorizationUri: string
  tokenUri: string
  clientId: string
  clientSecret: string
  snowflakeAccountName: string
  scopes?: string
}

export enum IDP {
  AZURE = 'azure',
  OKTA = 'okta',
  SNOWFLAKE = 'snowflake',
  CUSTOM = 'custom'
}

export const EXTERNAL_IDP_NAME = 'snowflake_integration'

export type AtInstallationSnowflakeConfig = {
  account: string
  password?: string
  username?: string
  database?: string
  role?: string // 'role',
}

export enum AtInstallationState {
  Available = 'available',
  Installing = 'installing',
  Unavailable = 'unavailable',
  Failed = 'failed'
}
export type AtInstallation = {
  id: string
  accountId: string
  providerId: ProviderType
  location?: string
  state: AtInstallationState
  installedAt?: string
  config?: AtInstallationSnowflakeConfig
  version: string | null
  output?: string | null

  // frontend only: used by
  latestAtVersion?: string | null
}

export type AtInstallationVersions = Partial<Record<ProviderType, string>>

export type DatabricksOAuthU2M = {
  id: string
  host: string
  clientId: string
  clientSecret: string
}

export type DatabricksOAuthU2MPayload = Pick<DatabricksOAuthU2M, 'host' | 'clientId' | 'clientSecret'>
